import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { debounceTime } from "rxjs/operators";
import { IGetTransportadora } from "src/app/services/TransportadoraService/transportadora.model";
import { TransportadoraService } from "src/app/services/TransportadoraService/transportadora.service";
import { formatarCpfCnpj } from "src/app/core/utils/utilities";
import { SwalAlertService } from "src/app/services/SwalAlertService/swalAlert.service";

@Component({
  selector: "app-listagem-transportadora",
  templateUrl: "./listagem-transportadora.component.html",
  styleUrls: ["./listagem-transportadora.component.scss"],
})
export class ListagemTransportadoraComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;

  form = this._inicializarFormulario();
  allData: IGetTransportadora[] = [];
  tableData: Array<any> = [];

  readonly PAGE_SIZE: number = 20;
  pageNumber: number = 1;
  maxPages: number = 1;

  tableColumns = [
    { header: "Código", key: "codigo", type: "text" },
    { header: "Nome", key: "nome", type: "text" },
    { header: "CNPJ", key: "cnpj", type: "text" },
    { header: "Contato", key: "contato", type: "text" },
    {
      header: "Ações",
      key: "actions",
      type: "buttons",
      buttons: [
        {
          label: "Editar",
          img: "assets/edit.svg",
          action: (item: any) => this.editarTransportadora(item),
        },
        {
          label: "Delete",
          img: "assets/trashcan.png",
          action: (item: any) => this.deletarTransportadora(item),
        },
      ],
    },
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private transportadoraService: TransportadoraService,
    public swalAlert: SwalAlertService,
  ) {}

  private _inicializarFormulario() {
    return this.fb.group({
      NM_TPTD: this.fb.control("", { nonNullable: true }),
    });
  }

  ngOnInit(): void {
    this.getTransportadoras();
  }

  ngAfterViewInit(): void {
    this.form.controls.NM_TPTD.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.pageNumber = 1;
      this.filtrarEPaginar();
    });
  }

  mudarPagina(pagina: number) {
    this.pageNumber = pagina + 1;
    this.filtrarEPaginar();
  }

  navegarCadastroTransportadora() {
    this.router.navigate(["cadastro/transportadora"]);
  }

  getTransportadoras() {
    this.isLoading = true;
    this.transportadoraService.GetTransportadoras().subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.allData = response?.Transportadoras ?? [];
        this.filtrarEPaginar();
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  private normalizar(texto: string): string {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  filtrarEPaginar() {
    const filtro = this.normalizar(this.form.controls.NM_TPTD.value);
    const filtered = filtro
      ? this.allData.filter((item) => this.normalizar(item.NM_TPTD ?? '').includes(filtro))
      : this.allData;

    this.maxPages = Math.max(1, Math.ceil(filtered.length / this.PAGE_SIZE));
    if (this.pageNumber > this.maxPages) this.pageNumber = 1;

    const start = (this.pageNumber - 1) * this.PAGE_SIZE;
    this.tableData = filtered.slice(start, start + this.PAGE_SIZE).map((item) => ({
      codigo: item.PK_TPTD,
      nome: item.NM_TPTD ?? "---",
      cnpj: item.TX_CNPJ_TPTD ? formatarCpfCnpj(item.TX_CNPJ_TPTD, "cnpj") : "---",
      contato: item.TX_CNTT_TPTD ?? "---",
    }));
  }

  editarTransportadora(item: any) {
    this.router.navigate(["cadastro/transportadora"], {
      queryParams: { codigo: item.codigo, modo: "Editar" },
    });
  }

  deletarTransportadora(item: any) {
    this.swalAlert.showAlert("Atenção!", "Deseja realizar a exclusão?", "warning", true, true, undefined, () => {
      this.transportadoraService.DeleteTransportadora(item.codigo).subscribe({
        next: () => {
          this.swalAlert.showAlert("Sucesso!", "Transportadora excluída com sucesso.", "success");
          this.getTransportadoras();
        },
        error: (err) => {
          this.swalAlert.handleError(err, "Erro!", "Ocorreu uma falha ao excluir a transportadora.");
        },
      });
    });
  }
}
